var _defs, _rect, _circle, _circle2, _g, _text, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClaudeai(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 360,
    viewBox: "0 0 640 360",
    role: "img",
    "aria-label": "Claude AI Integration with Salesforce",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d1f14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#da7756"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "url(#bg3)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 300,
    r: 120,
    fill: "#ffffff",
    opacity: 0.08
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 60,
    r: 90,
    fill: "#ffffff",
    opacity: 0.08
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60,96)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 150,
    height: 150,
    rx: 26,
    fill: "#ffffff",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 94,
    textAnchor: "middle",
    fontFamily: "Montserrat, Arial, sans-serif",
    fontSize: 58,
    fontWeight: 800,
    fill: "#ffffff"
  }, "\u2726"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 140,
    fontFamily: "Montserrat, Arial, sans-serif",
    fontSize: 36,
    fontWeight: 800,
    fill: "#ffffff"
  }, "Claude AI")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 184,
    fontFamily: "Montserrat, Arial, sans-serif",
    fontSize: 36,
    fontWeight: 800,
    fill: "#ffffff"
  }, "for Salesforce")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 226,
    fontFamily: "Montserrat, Arial, sans-serif",
    fontSize: 21,
    fill: "#f5ded4"
  }, "Apex-native integration with Anthropic's API")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaudeai);
export default __webpack_public_path__ + "static/media/claudeai.5549b22300d8ee627d642b31eca15a44.svg";
export { ForwardRef as ReactComponent };